export default __webpack_public_path__ + "static/media/angular2video.9041c0df.mp4";